import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGroup } from "../contexts/GroupContext.tsx";

export default function GroupLogin({ className = "", showCopyLink = false }) {
  const { t } = useTranslation();
  const { groupId, groupName, setGroupId } = useGroup();
  const [input, setInput] = useState("");
  const [editing, setEditing] = useState(false);

  // Se c'è già un gruppo attivo, mostra badge con opzione di uscita
  const [copied, setCopied] = useState(false);
  const handleCopyLink = () => {
    const url = new URL(window.location.href);
    url.hash = "";
    url.searchParams.set("community", groupId || "");
    navigator.clipboard.writeText(url.toString());
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };
  console.log("SHOW=", showCopyLink);
  const isDesktop = className.includes("desktop-group-login");
  if (groupId && !editing) {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          flexDirection: isDesktop ? "row" : undefined,
          flexWrap: isDesktop ? "nowrap" : undefined,
          alignItems: "center",
          gap: isDesktop ? 16 : 10,
          padding: "8px 14px",
          borderRadius: 20,
          background: "#e8f5e9",
          border: "1px solid #a5d6a7",
          fontSize: 14,
          fontWeight: 600,
          color: "#2e7d32",
          marginBottom: 16,
        }}
      >
        <span>👥 {groupName}</span>
        {showCopyLink && (
          <button
            onClick={handleCopyLink}
            style={{
              background: copied ? "#4CAF50" : "#fff",
              border: "1px solid #4CAF50",
              color: copied ? "#fff" : "#388e3c",
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              padding: "4px 10px",
              cursor: "pointer",
              transition: "all 0.2s",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              whiteSpace: "nowrap",
              alignSelf: "center",
            }}
            title="Copia link di accesso a questa community"
          >
            <span style={{ display: "inline-block", marginRight: 4 }}>🔗</span>
            <span style={{ display: "inline-block" }}>
              {copied
                ? t("link_copied", "Link copiato!")
                : t("copy_link", "Copia Link")}
            </span>
          </button>
        )}
        <button
          onClick={() => {
            setEditing(true);
            setInput("");
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 13,
            color: "#555",
          }}
          title="Cambia gruppo"
        >
          ✏️
        </button>
        <button
          onClick={() => {
            setGroupId(null);
            setEditing(false);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 13,
            color: "#c62828",
          }}
          title="Esci dal gruppo"
        >
          ✕
        </button>
      </div>
    );
  }

  const handleJoin = () => {
    const clean = input.trim().toLowerCase();
    if (!clean) return;
    const finalId = clean; // nessun prefisso automatico, si usa il codice esatto
    setGroupId(finalId);
    setEditing(false);
    setInput("");
  };

  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: isDesktop ? "row" : undefined,
        flexWrap: isDesktop ? "nowrap" : "wrap",
        alignItems: "center",
        gap: isDesktop ? 16 : 8,
        marginBottom: 16,
      }}
    >
      <input
        type="text"
        placeholder="Codice gruppo (es. amicidelmonte)"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleJoin()}
        style={{
          padding: "8px 12px",
          borderRadius: 8,
          border: "1px solid #ccc",
          fontSize: 14,
          minWidth: 220,
          outline: "none",
        }}
      />
      <button
        onClick={handleJoin}
        disabled={!input.trim()}
        style={{
          padding: "8px 16px",
          borderRadius: 8,
          background: input.trim() ? "#4CAF50" : "#ccc",
          color: "white",
          border: "none",
          fontSize: 14,
          fontWeight: 600,
          cursor: input.trim() ? "pointer" : "default",
          minHeight: 36,
        }}
      >
        {t("join_group", "Entra")}
      </button>
      {editing && (
        <button
          onClick={() => setEditing(false)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 13,
            color: "#888",
          }}
        >
          {t("join_group", "Annulla")}
        </button>
      )}
    </div>
  );
}
